const _excluded = ["name", "value", "onChange", "options", "showNullOption", "passEntireEvent", "id", "dataTestId", "label", "labelColSpan", "fieldName", "marginClass", "dropdownStyle", "labelStyle", "componentStyle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const DEFAULT_ID_PREFIX = 'dropdown';

/**
 * Dropdown with a few defaults to save a couple of copy pasted lines here and there.
 * Options: array of objects [{ key, value, text }] or array of strings (mapped to { key, value, text }).
 * Optional label/layout: pass label (and optionally labelColSpan, fieldName) to render as a row with label like TextFormFieldRow.
 *
 * @param {Array} options - Array of the form [{ key: string, value: string, text: string }] OR Array of strings
 */
export default function Dropdown(_ref) {
  let {
      name,
      value,
      onChange,
      options = [],
      showNullOption = true,
      passEntireEvent = false,
      id: idProp,
      dataTestId,
      label,
      labelColSpan = 3,
      fieldName,
      marginClass = 'mb-2',
      dropdownStyle = {
        minWidth: '200px'
      },
      labelStyle = {},
      componentStyle = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const field = fieldName !== null && fieldName !== void 0 ? fieldName : name;
  const id = idProp !== null && idProp !== void 0 ? idProp : "".concat(DEFAULT_ID_PREFIX, "_").concat(field).replace(/\./g, '_');
  if (dataTestId == null || dataTestId === '') {
    console.error('Dropdown: dataTestId is required for accessible testing. ' + "Provide dataTestId for field \"".concat(field, "\". Do not derive test id from label or id."));
  }
  let dropDownOptions = options;
  if (options.length > 0 && typeof options[0] === 'string') {
    dropDownOptions = options.map(o => ({
      key: o,
      value: o,
      text: o
    }));
  }
  const selectControl = /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: "select",
    id: id,
    name: name !== null && name !== void 0 ? name : field,
    value: value,
    onChange: e => onChange(passEntireEvent ? e : e.target.value),
    size: "md",
    type: "text",
    style: dropdownStyle,
    "data-testid": dataTestId || undefined
  }, props), showNullOption && /*#__PURE__*/React.createElement("option", {
    value: null
  }), dropDownOptions.map(o => {
    var _o$key;
    return /*#__PURE__*/React.createElement("option", {
      value: o.value,
      key: (_o$key = o.key) !== null && _o$key !== void 0 ? _o$key : o.value
    }, t(o.text));
  }));
  if (label != null) {
    return /*#__PURE__*/React.createElement(Form.Group, {
      className: "".concat(marginClass, " Dropdown Dropdown-").concat(field),
      as: Row,
      style: componentStyle
    }, /*#__PURE__*/React.createElement(Form.Label, {
      className: "Dropdown-FormLabel",
      column: "md",
      md: labelColSpan,
      htmlFor: id,
      style: labelStyle
    }, t("".concat(label))), /*#__PURE__*/React.createElement(Col, null, selectControl));
  }
  return selectControl;
}